module.exports = require("core-js-pure/stable/map");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/map.js
// module id = 564
// module chunks = 0 1